import React from "react";
import { Button, CircularProgress } from "@mui/material";

import "components/Screens/Marketplace/Customer/common/Button/button.scss";

interface CustomButtonProps {
  label: string;
  onClick: () => void;
  variant?: "contained" | "outlined" | "text";
  color?: "inherit-white" | "inherit-text" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
  size?: "small" | "medium" | "large";
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  isDisabled?: boolean;
  isLoading?: boolean;
  isFullWidth?: boolean;
  className?: string;
  disableHoverEffect?: boolean;
}

function CustomButton({
  label,
  onClick,
  variant = "contained",
  color = "primary",
  size = "medium",
  startIcon = null,
  endIcon = null,
  isDisabled = false,
  isLoading = false,
  isFullWidth = false,
  className = "",
  disableHoverEffect = false,
  ...other
}: CustomButtonProps) {
  function getColorClass() {
    if (isLoading) {
      return `button-${variant}-loading`;
    }
    return isDisabled ? `button-${variant}-disabled` : `button-${variant}-${color}`;
  }

  function getSizeClass() {
    switch (size) {
      case "small":
        return "button-small button-small-padding";
      case "large":
        return "button-large button-large-padding";
      default:
        return "button-medium button-medium-padding";
    }
  }

  return (
    <Button
      className={`${getColorClass()} ${getSizeClass()} ${className} button min-w-max-content ${
        disableHoverEffect ? "no-hover" : ""
      }`}
      size={size}
      variant={variant}
      disabled={isDisabled}
      onClick={!isLoading ? onClick : undefined}
      startIcon={startIcon}
      endIcon={endIcon}
      fullWidth={isFullWidth}
      {...other}
    >
      {isLoading ? <CircularProgress size={25} color="inherit" /> : label}
    </Button>
  );
}

export default CustomButton;
